import { useEffect } from 'react'

import { FloatingLoader } from '~/@common/ui/(Loader)/FloatingLoader'

import { useNaverWorksLogin } from './useNaverWorksLogin'

/**
 * 네이버 웍스(웨일 스페이스) SSO 인가 요청 진입점 (/whale/connect).
 * 로그인 페이지 등에서 이 경로로 보내면 즉시 네이버 웍스 authorize URL로
 * 전체 페이지 이동하며, 콜백은 /whale/callback으로 돌아온다.
 *
 * ⚠️ 경로값은 파트너사 redirect_uri 등록값이 아니지만 로그인 링크에서 참조하므로 유지.
 */
const AiOnOAuthLoginPage = () => {
  const { authURI } = useNaverWorksLogin()

  useEffect(() => {
    window.location.replace(authURI)
    // mount 시 한 번만 redirect (authURI는 매 렌더마다 state가 갱신됨)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <FloatingLoader />
}

export default AiOnOAuthLoginPage
